import { ASSETS_CDN_URL } from "./ThirdPartyConstants";

/* Since the script download-assets.js actually needs the url to download the assets, we need the urls we get from server response at build time. */

export const postgresqlIcon = `${ASSETS_CDN_URL}/logo/postgresql.svg`;
export const mongodbIcon = `${ASSETS_CDN_URL}/logo/mongodb.svg`;
export const restApiIcon = `${ASSETS_CDN_URL}/RestAPI.png`;
export const mysqlIcon = `${ASSETS_CDN_URL}/logo/mysql.svg`;
export const elasticIcon = `${ASSETS_CDN_URL}/logo/elastic.svg`;
export const dynamoDBIcon = `${ASSETS_CDN_URL}/logo/aws-dynamodb.svg`;
export const redisIcon = `${ASSETS_CDN_URL}/logo/redis.svg`;
export const mssqlIcon = `${ASSETS_CDN_URL}/logo/mssql.svg`;
export const s3Icon = `${ASSETS_CDN_URL}/logo/aws-s3.svg`;
export const googleSheetsIcon = `${ASSETS_CDN_URL}/GoogleSheets.svg`;
export const snowflakeIcon = `${ASSETS_CDN_URL}/logo/snowflake.svg`;
export const arangodbIcon = `${ASSETS_CDN_URL}/logo/arangodb.svg`;
export const jsFileIcon = `${ASSETS_CDN_URL}/JSFile.svg`;
export const smtpIcon = `${ASSETS_CDN_URL}/smtp-icon.svg`;
export const graphqlIcon = `${ASSETS_CDN_URL}/logo/graphql.svg`;
export const oracleIcon = `${ASSETS_CDN_URL}/oracle-db.jpg`;

// Unsupported plugin assets
export const openaiLogo = `${ASSETS_CDN_URL}/integrations/openai-logo-png.jpg`;
export const firestoreIcon = `${ASSETS_CDN_URL}/logo/firestore.svg`;
export const redshiftIcon = `${ASSETS_CDN_URL}/logo/aws-redshift.svg`;
export const hubspotIcon = `${ASSETS_CDN_URL}/integrations/HubSpot.png`;
export const airtableIcon = `${ASSETS_CDN_URL}/integrations/airtable.svg`;
export const twilioIcon = `${ASSETS_CDN_URL}/integrations/twilio_24.png`;
export const twilioIcon1 = `${ASSETS_CDN_URL}/integrations/twilio_1.png`;
export const sendgridTwilioIcon = `${ASSETS_CDN_URL}/integrations/sendgrid_twilio.jpg`;
export const huggingFaceLogo = `${ASSETS_CDN_URL}/integrations/Hugging-Face-Logo.png`;
export const dropboxIcon = `${ASSETS_CDN_URL}/integrations/dropbox.png`;
export const figmaIcon = `${ASSETS_CDN_URL}/integrations/Figma-1-logo.png`;

// Assets for CRUD page generator
export const sqlWorkflowIcon = `${ASSETS_CDN_URL}/crud/workflow_sql.svg`;
export const s3WorkflowIcon = `${ASSETS_CDN_URL}/crud/workflow_s3.svg`;

// Assets from tenant configuration
export const appsmithFavicon = `${ASSETS_CDN_URL}/appsmith-favicon-orange.ico`;
